import Component from './expand'

export default Component